import React from 'react';
import Counter from './Counter'; // Importamos el componente Counter

function FactsSection() {
  return (
    <div className="container-fluid facts my-5 py-5" data-parallax="scroll" data-image-src="/img/banner.jpeg">
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-sm-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
            <Counter end={459} duration={2000} />
            <span className="text-primary">Nuetros Clientes</span>
          </div>
          <div className="col-sm-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
            <Counter end={600} duration={2000} />
            <span className="text-primary">Projects Completados</span>
          </div>
          <div className="col-sm-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
            <Counter end={350} duration={2000} />
            <span className="text-primary">Equipos Instalados</span>
          </div>
          <div className="col-sm-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
            <Counter end={200} duration={2000} />
            <span className="text-primary">Empresas</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FactsSection;